import { gql } from '@apollo/client';
import Fragments from '../queries/fragments';

const { MEDIA_PLAYBACK_FIELDS } = Fragments;

const BOOTSTRAP_SELECTED_FILTERS = gql`
    mutation SetSelectedFilters($selectedFilters: [FilterSelection]!) {
        setSelectedFilters(selectedFilters: $selectedFilters) @client
    }
`;

const REMOVE_SELECTED_FILTER = gql`
    mutation RemoveSelectedFilter($fieldName: String!, $value: String!) {
        removeSelectedFilter(fieldName: $fieldName, value: $value) @client
    }
`;

const ADD_SELECTED_FILTER = gql`
    mutation AddSelectedFilter($filter: FilterSelection!) {
        addSelectedFilter(filter: $filter) @client
    }
`;

const SET_SEARCH_SORT = gql`
    mutation SetSearchSort($searchSort: String!) {
        setSearchSort(searchSort: $searchSort) @client
    }
`;

const MODAL_SHOW = gql`
    mutation ModalShow($name: String!) {
        modalShow(name: $name) @client
    }
`;

const MODAL_HIDE = gql`
    mutation ModalHide($name: String!) {
        modalHide(name: $name) @client
    }
`;

const MODAL_TOGGLE = gql`
    mutation ModalToggle($name: String!) {
        modalToggle(name: $name) @client
    }
`;

const SET_IS_EU = gql`
    mutation SetIsEU($isEU: Boolean ) {
        setIsEU(isEU: $isEU) @client
    }
`;

const SET_TARGET_OFFER = gql`
    mutation SetTargetOffer($targetOffer: String) {
        setTargetOffer(targetOffer: $targetOffer) @client
    }
`;

const SET_REEL = gql`
    mutation SetReel($reel: Reel!) {
        setReel(reel: $reel) @client
    }
`;

const RESET_REEL = gql`
    mutation ResetReel {
        resetReel @client
    }
`;

const ADD_REEL_CLIP = gql`
    mutation AddReelClip(
        $mediaId: String!,
        $title: String!,
        $clipSlug: String!,
        $feedType: String!,
        $thumbnailUrl: String!,
        $originalDuration: Float!,
    ) {
        addReelClip (
            mediaId: $mediaId,
            title: $title,
            clipSlug: $clipSlug,
            feedType: $feedType,
            thumbnailUrl: $thumbnailUrl,
            originalDuration: $originalDuration,
        ) @client
    }
`;

const REMOVE_REEL_CLIP = gql`
    mutation RemoveReelClip($mediaId: String!) {
        removeReelClip(mediaId: $mediaId) @client
    }
`;

const REORDER_REEL_CLIP = gql`
    mutation ReorderReelClip($startIndex: Int!, $endIndex: Int! ) {
        reorderReelClip(startIndex: $startIndex, endIndex: $endIndex) @client
    }
`;

const UPDATE_REEL_CLIP = gql`
    mutation UpdateReelClip(
        $mediaId: String!
        $offsetStartTime: Float
        $offsetEndTime: Float
        $originalDuration: Float
    ) {
        updateReelClip(
            mediaId: $mediaId
            offsetStartTime: $offsetStartTime
            offsetEndTime: $offsetEndTime
            originalDuration: $originalDuration
        ) @client
    }
`;

const SET_REEL_CLIP_TRIMMING_MEDIA_ID = gql`
    mutation SetReelClipTrimmingMediaId(
        $mediaId: String!,
    ) {
        setReelClipTrimmingMediaId (
            mediaId: $mediaId,
        ) @client
    }
`;

const SET_SHARE_MEDIA_ID = gql`
    mutation SetShareMediaId(
        $mediaId: String!,
    ) {
        setShareMediaId (
            mediaId: $mediaId,
        ) @client
    }
`;

const CREATE_REEL = gql`
    mutation CreateReel(
        $reelRequest: ReelInput!
        $withPlaybacksSegments: Boolean = false
    ) {
        addReel(reelRequest: $reelRequest) {
            id
            reelTitle
            reelSlug
            videoUrl
            thumbnailUrl
            duration
            createdAt
            valid
            errors
            mediaPlayback {
                ...MediaPlaybackFields
            }
        }
    }
    ${MEDIA_PLAYBACK_FIELDS}
`;

const DELETE_REEL = gql`
    mutation DeleteReel(
        $reelId: String!
    ) {
        deleteReel(reelId: $reelId) {
            deleted
            reelId
        }
    }
`;

const DISMISS_NOTIFICATION = gql`
    mutation dismissNotification(
        $id: String!
    ) {
        dismissNotification (
            id: $id
        ) @client
    }
`;

const SET_DELETE_REEL_ID = gql`
    mutation SetDeleteReelId(
        $mediaId: String!,
    ) {
        setDeleteReelId (
            mediaId: $mediaId,
        ) @client
    }
`;

const SET_IS_SORTING = gql`
    mutation SetIsSorting($isSorting: Boolean ) {
        setIsSorting(isSorting: $isSorting) @client
    }
`;

export default {
    BOOTSTRAP_SELECTED_FILTERS,
    REMOVE_SELECTED_FILTER,
    ADD_SELECTED_FILTER,
    MODAL_SHOW,
    MODAL_HIDE,
    MODAL_TOGGLE,
    SET_IS_EU,
    SET_TARGET_OFFER,
    SET_REEL,
    RESET_REEL,
    ADD_REEL_CLIP,
    REMOVE_REEL_CLIP,
    REORDER_REEL_CLIP,
    UPDATE_REEL_CLIP,
    SET_REEL_CLIP_TRIMMING_MEDIA_ID,
    SET_SHARE_MEDIA_ID,
    CREATE_REEL,
    DELETE_REEL,
    DISMISS_NOTIFICATION,
    SET_DELETE_REEL_ID,
    SET_SEARCH_SORT,
    SET_IS_SORTING,
};
